import { useMemo } from 'react';

import { type WorkspaceAgentComposerScopePill } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/usePrivateWorkspaceAgentComposerPills';
import { useWorkspaceAgentClipsForClipIds } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/useWorkspaceAgentClipsForClipIds';
import {
  getWorkspaceAgentGuidedVariantSkipCounts,
  type WorkspaceAgentGuidedVariantSkipCounts,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/getWorkspaceAgentGuidedVariantSkipCounts';

export type PrivateWorkspaceAgentGuidedVariantSelection = {
  assetCount: number;
  skipCounts: WorkspaceAgentGuidedVariantSkipCounts;
};

export const usePrivateWorkspaceAgentGuidedVariantSelection = (
  scopePills: readonly WorkspaceAgentComposerScopePill[],
): PrivateWorkspaceAgentGuidedVariantSelection => {
  const assetClipIds = useMemo(
    () => scopePills.filter((pill) => pill.type === 'asset').map((pill) => pill.id),
    [scopePills],
  );
  const clips = useWorkspaceAgentClipsForClipIds(assetClipIds);
  const skipCounts = useMemo(() => getWorkspaceAgentGuidedVariantSkipCounts(clips), [clips]);

  return {
    assetCount: assetClipIds.length,
    skipCounts,
  };
};
